import { Box } from '@mui/system';
import Typography from '@mui/material/Typography';
import ItemIcon from './ItemIcon';

function FileItem(props) {
  const { item, onClick } = props;

  if (!item) {
    return null;
  }

  return (
    <Box
      sx={{ backgroundColor: 'background.paper' }}
      className="relative w-full sm:w-160 h-160 m-8 p-16 shadow rounded-16 cursor-pointer"
      onClick={onClick}
    >
      <div className="flex flex-auto w-full items-center justify-center">
        <ItemIcon className="" type={item.type} />
      </div>
      <div className="flex shrink flex-col justify-center text-center">
        <Typography className="truncate text-12 font-medium">{item.name}</Typography>
        {item.description && (
          <Typography className="truncate text-12 font-medium" color="text.secondary">
            {item.description}
          </Typography>
        )}
      </div>
    </Box>
  );
}

export default FileItem;
